import React from 'react';

function Stack(props) {
  return (
    <div>
      {/* <a frameBorder="0" data-theme="light" data-layers="1,2,4,3" data-stack-embed="true" href=""></a>
      {useScript("https://cdn1.stackshare.io/javascripts/client-code.js")} */}
    </div>
  )
};

export default Stack;
